export default function PuaSearch(){
    return (
        <div className="">
          Error
        </div>
      )
}